export default {
  creationTime: "Hora de Creación",
  creationDate: "Fecha de Creación",
  measurementDate: "Fecha de Medición",
  last24Hours: "Últimas 24 Horas",
  last3Days: "Últimos 3 Días",
  lastWeek: "Última Semana",
  last2Weeks: "Últimas 2 Semanas",
  lastMonth: "Último Mes",
  lastYear: "Último Año",
  date: "fecha",
  hours: "horas",
  minutes: "minutos",
  hour: "hora",
  minute: "minuto",
  morning: "mañana",
  afternoon: "tarde",
  evening: "noche",
  timeBucket: {
    tenMin: "10 min",
    oneHour: "1 hora",
    sixHours: "6 horas",
    twelveHours: "12 horas",
    twentyfourHours: "24 horas",
  },
};
